  (function waitForFlickity() {
    if (typeof jQuery_T4NT === 'undefined') {
      return setTimeout(waitForFlickity, 100);
    }

    document.querySelectorAll('[data-t4s-gallery]').forEach(function (carousel) {
      var $c = jQuery_T4NT(carousel);
      var flkty = $c.data('flickityt4s');

      // Flickity may not be initialized yet — retry
      if (!flkty) {
        return setTimeout(waitForFlickity, 200);
      }

      $c.on('select.flickityt4s', function () {
        // force drag back on after _switchMedia disables it on video/3D slides
        setTimeout(function () {
          flkty.options.draggable = true;
          flkty.updateDraggable();
        }, 50);
      });
    });
  })();